/* projects/fitnessforservice/src/app/assessments/local-metal-loss-profile-data/local-metal-loss-profile-data.component.css */
.smaller-table th,
.smaller-table td {
  width: 5px;
  padding: 8px;
}
.smaller-table tr {
  height: 20px;
  width: 5px;
}
.smaller-table td input {
  height: 25px;
  width: 65px;
}
.smaller-table td mat-checkbox {
  height: 10px;
  width: 10px;
}
.ltap-print-report-disabled {
  cursor: not-allowed;
}
.ltap-print-report-disabled ::ng-deep button[disabled] {
  background-color: #cccccc;
  border-color: #bbbbbb;
  color: #666666;
  opacity: 1;
}
/*# sourceMappingURL=local-metal-loss-profile-data.component.css.map */
